import angular from 'angular';

angular
  .module('myConsultApp')
  .service(
    'UserService',
    function (
      $cookieStore,
      $localStorage,
      $location,
      $resource,
      $rootScope,
      $window,
      AuthService,
      $timeout,
      ATLAS_API,
      ENV,
      redirectToUrlAfterLogin,
      Session,
    ) {
      this.accessToken = Session.accessToken ? Session.accessToken : null;
      this.refreshToken = Session.refreshToken ? Session.refreshToken : null;
      this.expiresIn = Session.expiresIn ? Session.expiresIn : null;

      this.currentUser = $localStorage.currentUser ? $localStorage.currentUser : null;
      this.isAdminUser = $localStorage.isAdminUser ? $localStorage.isAdminUser : false;
      this.isDeveloperUser = $localStorage.isDeveloperUser ? $localStorage.isDeveloperUser : false;
      this.isKittyhawkSuperuser = $localStorage.isKittyhawkSuperuser ? $localStorage.isKittyhawkSuperuser : false;
      this.isSuperUser = $localStorage.isSuperUser ? $localStorage.isSuperUser : false;
      this.vetOrganizations = $localStorage.vetOrganizations
        ? $localStorage.vetOrganizations
        : false;
      this.currentOrganization = $localStorage.currentOrganization
        ? $localStorage.currentOrganization
        : false;
      this.subscriptions = {
        isPWRSubscribed: $localStorage.isPWRSubscribed ? $localStorage.isPWRSubscribed : false,
        isRewardsSubscribed: $localStorage.isRewardsSubscribed
          ? $localStorage.isRewardsSubscribed
          : false,
        isTiggerSubscribed: $localStorage.isTiggerSubscribed
          ? $localStorage.isTiggerSubscribed
          : false,
        isSolensiaSubscribed: $localStorage.isSolensiaSubscribed
          ? $localStorage.isSolensiaSubscribed
          : false,
        isLibrelaSubscribed: $localStorage.isLibrelaSubscribed
          ? $localStorage.isLibrelaSubscribed
          : false,
      };
      this.baseUser = $localStorage.baseUser ? $localStorage.baseUser : null;
      this.baseUserId = $localStorage.baseUserId ? $localStorage.baseUserId : null;

      this.checkAdminAuth = async () => {
        this.isAdminUser = false;
        this.isDeveloperUser = false;
        this.isKittyhawkSuperuser = false;
        $localStorage.isAdminUser = false;
        $rootScope.isAdminUser = false;
        $localStorage.isDeveloperUser = false;
        $rootScope.isDeveloperUser = false;
        $localStorage.isKittyhawkSuperuser = false;
        $rootScope.isKittyhawkSuperuser = false;
        this.isSuperUser = false;
        $localStorage.isSuperUser = null;
        $rootScope.isSuperUser = false;
        this.currentUser = await this.checkUser();
        if (this.currentUser) {
          await this.setCurrentUser(this.currentUser);
          await this.checkAndSetAdminAndSuperuser();
        } else {
          await this.unsetOptions();
        }
        return [
          this.currentUser,
          this.isAdminUser,
          this.isDeveloperUser,
          this.isKittyhawkSuperuser,
          this.isSuperUser,
          this.vetOrganizations,
          this.currentOrganization,
          this.subscriptions,
          this.baseUser,
        ];
      };

      this.unsetOptions = () => {
        this.currentUser = null;
        this.isAdminUser = false;
        this.isDeveloperUser = false;
        this.isKittyhawkSuperuser = false;
        this.isSuperUser = false;
        this.currentOrganization = null;
        this.vetOrganizations = null;
        this.subscriptions = {
          isPWRSubscribed: false,
          isRewardsSubscribed: false,
          isTiggerSubscribed: false,
          isSolensiaSubscribed: false,
          isLibrelaSubscribed: false,
        };
        this.baseUser = null;
        this.baseUserId = null;

        $localStorage.currentUser = null;
        $localStorage.isAdminUser = false;
        $localStorage.isDeveloperUser = false;
        $localStorage.isKittyhawkSuperuser = false;
        $localStorage.isSuperUser = null;
        $localStorage.currentOrganization = null;
        $localStorage.vetOrganizations = null;
        $localStorage.subscriptions = {
          isPWRSubscribed: false,
          isRewardsSubscribed: false,
          isTiggerSubscribed: false,
          isSolensiaSubscribed: false,
          isLibrelaSubscribed: false,
        };
        $localStorage.isPWRSubscribed = false;
        $localStorage.isRewardsSubscribed = false;
        $localStorage.isTiggerSubscribed = false;
        $localStorage.baseUser = null;
        $localStorage.baseUserId = null;

        $rootScope.currentUser = null;
        $rootScope.isAdminUser = false;
        $rootScope.isDeveloperUser = false;
        $rootScope.isKittyhawkSuperuser = false;
        $rootScope.isSuperUser = false;
        $rootScope.currentOrganization = null;
        $rootScope.vetOrganizations = null;
        $rootScope.subscriptions = {
          isPWRSubscribed: false,
          isRewardsSubscribed: false,
          isTiggerSubscribed: false,
          isSolensiaSubscribed: false,
          isLibrelaSubscribed: false,
        };
        $rootScope.isPWRSubscribed = false;
        $rootScope.isRewardsSubscribed = false;
        $rootScope.isTiggerSubscribed = false;
        $rootScope.isSolensiaSubscribed = false;
        $rootScope.isLibrelaSubscribed = false;
        $rootScope.baseUser = null;
        $rootScope.baseUserId = null;
        localStorage.clear();
      };

      this.checkAndGrabUserInfo = async () => {
        if (!this.currentUser) {
          this.currentUser = await this.checkUser();
        }
        if (this.currentUser) {
          await this.setCurrentUser(this.currentUser);
          await this.checkAndSetAdminAndSuperuser();
          await this.redirectUser();
          $rootScope.addSuperUserConfig();
          return [
            this.currentUser,
            this.isAdminUser,
            this.isDeveloperUser,
            this.isKittyhawkSuperuser,
            this.isSuperUser,
            this.vetOrganizations,
            this.currentOrganization,
            this.subscriptions,
            this.baseUser,
          ];
        }
      };

      this.checkUser = function () {
        var user = $resource(
          ENV.apiEndpoint + '/2.0/me/',
          {},
          {
            get: {
              headers: {
                Authorization: 'Bearer ' + Session.accessToken,
              },
            },
          },
        );

        return user.get().$promise.then(function (response) {
          return response.me;
        });
      };

      this.getCurrentUser = async () => {
        if ($localStorage.currentUser || this.currentUser) {
          var user = this.currentUser ? this.currentUser : $localStorage.currentUser;
          await this.setCurrentUser($localStorage.currentUser);
        }
        return $localStorage.currentUser;
      };

      this.setCurrentUser = async (user) => {
        $rootScope.currentUser = user;
        $localStorage.currentUser = user;
        this.currentUser = user;
        await Session.create(user.id, user.email);
      };

      this.checkAndSetAdminAndSuperuser = async () => {
        var groups = this.currentUser.groups;
        for (var i = 0; i < groups.length; i++) {
          if (groups[i].name === 'Administrators') {
            this.isAdminUser = true;
            $localStorage.isAdminUser = true;
            $rootScope.isAdminUser = true;
          }
          if (groups[i].name === 'Super Users') {
            this.isSuperUser = true;
            $localStorage.isSuperUser = true;
            $rootScope.isSuperUser = true;
          }
          if (groups[i].name === 'Developer Users') {
            this.isDeveloperUser = true;
            $localStorage.isDeveloperUser = true;
            $rootScope.isDeveloperUser = true;
          }
          if (groups[i].name === 'Kittyhawk Super Users') {
            this.isKittyhawkSuperuser = true;
            $localStorage.isKittyhawkSuperuser = true;
            $rootScope.isKittyhawkSuperuser = true;
          }
        }
        if (this.isAdminUser || this.isSuperUser || this.isDeveloperUser || this.isKittyhawkSuperuser) {
          await Session.create(this.currentUser.id, this.currentUser.contact_information.email);
        } else {
          $localStorage.isAdminUser = false;
          $rootScope.isAdminUser = false;
          $localStorage.isSuperUser = false;
          $rootScope.isSuperUser = false;
          $localStorage.isDeveloperUser = false;
          $rootScope.isDeveloperUser = false;
          $localStorage.isKittyhawkSuperuser = false;
          $rootScope.isKittyhawkSuperuser = false;
        }
      };

      // Set Subscription for Paw Path Organization User
      this.setSubscriptions = function () {
        if (this.currentOrganization) {
          const application = this.currentOrganization.applications;
          $localStorage.subscriptions = {
            isPWRSubscribed: false,
            isRewardsSubscribed: false,
            isTiggerSubscribed: false,
            isSolensiaSubscribed: false,
            isLibrelaSubscribed: false,
          };

          this.isPWRSubscribed = false;
          this.isRewardsSubscribed = false;
          this.isTiggerSubscribed = false;
          this.isSolensiaSubscribed = false;
          this.isLibrelaSubscribed = false;

          for (var i = 0; i < application.length; i++) {
            if (application[i].name === 'PWR' && application[i].is_active === true) {
              this.subscriptions.isPWRSubscribed = true;
              $localStorage.subscriptions.isPWRSubscribed = true;
            }
            if (application[i].name === 'LOYALTY' && application[i].is_active === true) {
              this.subscriptions.isRewardsSubscribed = true;
              $localStorage.subscriptions.isRewardsSubscribed = true;
            }
            if (application[i].name === 'TIGGER' && application[i].is_active === true) {
              this.subscriptions.isTiggerSubscribed = true;
              $localStorage.subscriptions.isTiggerSubscribed = true;
            }
            if (application[i].name === 'SOLENSIA' && application[i].is_active === true) {
              this.subscriptions.isSolensiaSubscribed = true;
              $localStorage.subscriptions.isSolensiaSubscribed = true;
            }
            if (application[i].name === 'LIBRELA-IEP' && application[i].is_active === true) {
              this.subscriptions.isLibrelaSubscribed = true;
              $localStorage.subscriptions.isLibrelaSubscribed = true;
            }
          }
        } else {
          this.isPWRSubscribed = false;
          this.isRewardsSubscribed = false;
          this.isTiggerSubscribed = false;
          this.isSolensiaSubscribed = false;
          this.isLibrelaSubscribed = false;
          this.subscriptions = {
            isPWRSubscribed: false,
            isRewardsSubscribed: false,
            isTiggerSubscribed: false,
            isSolensiaSubscribed: false,
            isLibrelaSubscribed: false,
          };
          $localStorage.subscriptions = this.subscriptions;
        }
      };

      this.redirectUser = () => {
        // if (redirectToUrlAfterLogin.url !== '/' && redirectToUrlAfterLogin.url !== '/login') {
        //   if ($location.$$path !== redirectToUrlAfterLogin.url) {
        //     $location.path(redirectToUrlAfterLogin.url);
        //   }
        // } else {
        //   if (!this.isAdminUser) {
        //     if (this.subscriptions.isTiggerSubscribed && this.subscriptions.isRewardsSubscribed) {
        //       if ($location.$$path != '/') {
        //         $location.path('/');
        //       }
        //     } else if (this.subscriptions.isTiggerSubscribed) {
        //       if ($location.$$path != '/catpainiq') {
        //         $location.path('/catpainiq');
        //       }
        //     } else {
        //       if ($location.$$path != '/rewards') {
        //         $location.path('/rewards');
        //       }
        //     }
        //   } else {
        //     if ($location.$$path != '/admin') {
        //       $location.path('/admin');
        //     }
        //   }
        // }

        if (redirectToUrlAfterLogin.url !== '/') {
          $window.location.href = redirectToUrlAfterLogin.url;
          return;
        }

        if (this.isAdminUser) {
          $window.location.href = '/admin/users/manage-users';
          return;
        }

        if (this.isDeveloperUser) {
          $window.location.href = '/admin/developers/api-documentation';
          return;
        }

        $timeout(() => {
          $window.location.href = ENV.proURL;
        }, 300);
      };

      this.isValid = function () {
        var valid = false;
        Session.loadTokens();
        if (
          Session.accessToken &&
          Session.refreshToken &&
          Session.expiresIn &&
          this.currentUser &&
          (this.isAdminUser || this.isSuperUser || this.isDeveloperUser || this.isKittyhawkSuperuser || this.currentOrganization)
        ) {
          valid = true;
        } else if (Session.refreshToken) {
          let credentials = {
            client_id: ATLAS_API.clientId,
            grant_type: 'refresh_token',
            refresh_token: Session.refreshToken,
          };
          AuthService.refreshToken(credentials).then(function (response) {
            Session.setTokens(response.access_token, response.refresh_token, response.expires_in);
            this.checkAndGrabUserInfo().then(function (response) {
              valid = true;
            });
          });
        } else {
          $cookieStore.remove('csrftoken');
          $cookieStore.remove('sessionid');
          Session.destroy();
          $localStorage.currentUser = null;
          $localStorage.isAdminUser = null;
          $localStorage.isDeveloperUser = null;
          $localStorage.isKittyhawkSuperuser = null;
          $localStorage.isSuperUser = null;
          $rootScope.currentUser = null;
          $rootScope.isAdminUser = false;
          $rootScope.isDeveloperUser = false;
          $rootScope.isKittyhawkSuperuser = false;
          $rootScope.isSuperUser = false;
          this.unsetOptions();
        }
        return valid;
      };

      this.checkSuperUser = function () {
        var valid = false;

        if (
          Session.baseAccessToken &&
          Session.baseRefreshToken &&
          Session.baseExpiresIn &&
          Session.baseUserId
        ) {
          valid = true;
        }
        return valid;
      };
    },
  );
